import {
  EdgeDirectionType,
  ExposureDirectionType,
  SizingCalculatorAttributesType
} from 'data/types';
import { wallCardinal } from 'utils/wall-cardinal';

const ALL_EDGE_DIRECTIONS: EdgeDirectionType[] = [
  'top',
  'right',
  'bottom',
  'left'
];

export function spaceHasWallOnEdge(
  sizingAttributes: SizingCalculatorAttributesType | undefined,
  edge: EdgeDirectionType,
  homeOrientation: ExposureDirectionType | undefined
): boolean {
  if (!sizingAttributes) {
    return false;
  }

  return [
    ...sizingAttributes.aboveGradeWalls,
    ...sizingAttributes.belowGradeWalls
  ].some((wall) => wallCardinal(wall, homeOrientation) === edge);
}

export function spaceWallEdges(
  sizingAttributes: SizingCalculatorAttributesType | undefined,
  homeOrientation: ExposureDirectionType | undefined
): EdgeDirectionType[] {
  return ALL_EDGE_DIRECTIONS.filter((edge) =>
    spaceHasWallOnEdge(sizingAttributes, edge, homeOrientation)
  );
}
